export interface Alarm {
  name: string;
  periodInMinutes?: number;
  scheduledTime: number;
  delayInMinutes?: number;
}

export interface AlarmOptions {
  delayInMinutes?: number;
  periodInMinutes?: number;
  when?: number;
}

export interface AccountInfo {
  id: string;
}

export interface UserInfo extends AccountInfo {
  email: string;
}

export enum AccountStatus {
  SYNC = 'SYNC',
  ANY = 'ANY',
}

export interface ProfileDetails {
  accountStatus: AccountStatus;
}

export interface Manifest {
  version: string;
  action?: {
    default_title?: string;
  };
}

export interface DeviceDetails {
  id: string;
  serialNumber: string;
  assetId?: string;
}

export type IdleState = 'active' | 'idle' | 'locked';

export interface LocalOverrides {
  osVersion?: string;
  device?: DeviceDetails;
  network?: NetworkDetails;
}

export interface NetworkDetails {
  ipv4?: string;
  ipv6?: string;
  macAddress?: string;
}
